import React from 'react';
import './social.scss';

export function Social() {
  return (
    <section id="social">
      <h2 className='social-title'>Мы в соцсетях</h2>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2"></div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
          <div id="vk_groups" className='vkgroups'></div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
          <a className='btnvk' href="https://vk.com/naolivet" target="_blank" title="Мы в VK" rel="noreferrer"></a>
        </div>
      </div>
    </section>
  );
}
